import React from 'react';
import PageTitle from '../FormElements/PageTitle';
import GlobalErrorsBox from '../ErrorComponents/GlobalErrorBox/GlobalErrorsBox';
import FormSection from '../FormElements/FormSection';
import FormSubmit from '../FormElements/FormSubmit';
import Label from '../FormElements/Label';
import TextInput from '../FormElements/TextInput';
import EmailInput from '../FormElements/EmailInput';
import PhoneNumberInput from '../FormElements/PhoneNumberInput';
import DropdownList from '../FormElements/DropdownList';
import PrimaryButton from '../Buttons/PrimaryButton';
import SecondaryButton from '../Buttons/SecondaryButton';
import statesFullName from '../../helpers/statesFullName';

export default class AccountForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			name: '',
			mailing_address_1: '',
			mailing_address_2: '',
			mailing_city: '',
			mailing_state: '',
			mailing_postal_code: '',
			phone_number: '',
			errorsList: [],
			fieldErrors: {}
		};

		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}

	componentDidMount() {
		if (this.props.isEditing) {
			this.loadData();
		}
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	}

	render() {
		// console.log('AccountForm', this.props, this.state);
		return (
			<div className="w-full py-4">
				<PageTitle
					title={
						this.props.isEditing ? (
							'Update your account profile'
						) : (
							'Create your account profile'
						)
					}
				/>
				<GlobalErrorsBox globalErrors={this.state.errorsList} />
				<FormSection>
					<Label htmlFor="name">Account Name *</Label>
					<TextInput
						id="name"
						name="name"
						value={this.state.name}
						onChange={this.onChange}
						placeholder="e.g. Island Properties, LLC"
						helperText="Your company name. If you don't have one, use a nickname (e.g. Matt's Properties)"
						fieldErrors={this.state.fieldErrors}
					/>
					<Label htmlFor="mailingAddress1">Mailing Address Line 1 *</Label>
					<TextInput
						id="mailing_address_1"
						name="mailing_address_1"
						value={this.state.mailing_address_1}
						onChange={this.onChange}
						fieldErrors={this.state.fieldErrors}
					/>
					<Label htmlFor="mailing_address_2">Mailing Address Line 2</Label>
					<TextInput
						id="mailing_address_2"
						name="mailing_address_2"
						value={this.state.mailing_address_2}
						onChange={this.onChange}
						fieldErrors={this.state.fieldErrors}
					/>
					<Label htmlFor="mailing_city">Mailing Address City *</Label>
					<TextInput
						id="mailing_city"
						name="mailing_city"
						value={this.state.mailing_city}
						onChange={this.onChange}
						fieldErrors={this.state.fieldErrors}
					/>
					<DropdownList
						label="Mailing State *"
						width="w-full"
						displayLabel={true}
						onChange={this.onChange}
						id="mailing_state"
						name="mailing_state"
						value={this.state.mailing_state}
						data={statesFullName}
						fieldErrors={this.state.fieldErrors}
					/>
					<Label htmlFor="mailing_postal_code">
						Mailing Address Zip Code *
					</Label>
					<TextInput
						id="mailing_postal_code"
						name="mailing_postal_code"
						value={this.state.mailing_postal_code}
						onChange={this.onChange}
						fieldErrors={this.state.fieldErrors}
					/>
					<Label htmlFor="phone_number">Phone Number *</Label>
					<TextInput
						id="phone_number"
						name="phone_number"
						value={this.state.phone_number}
						onChange={this.onChange}
						fieldErrors={this.state.fieldErrors}
					/>
				</FormSection>
				<div className="grid">
					<div className="lg:justify-self-end">
						<FormSubmit
							onSubmit={this.onSubmit}
							label={
								this.props.isEditing ? (
									'Save changes'
								) : (
									'Create account and continue'
								)
							}
						/>
					</div>
				</div>
				{/*	<PrimaryButton
						label="Test - Back"
						onClick={this.props.backLocation}
					/>
					<SecondaryButton
						label="Test - Continue"
						onClick={this.props.continueLocation}
					/> */}
			</div>
		);
	}

	onChange(e) {
		let { ...state } = this;
		state[e.target.name] = e.target.value;
		this.setState(state);
	}

	onSubmit(e) {
		// console.log('Create account call stated...');
		e.preventDefault();
		e.stopPropagation();

		$.ajax({
			type: 'POST',
			url: this.props.isEditing
				? this.props.update_account_endpoint.replace('id', 1)
				: this.props.create_account_endpoint,
			dataType: 'json',
			data: {
				account: {
					user_id: this.props.userId,
					name: this.state.name,
					mailing_address_1: this.state.mailing_address_1,
					mailing_address_2: this.state.mailing_address_2,
					mailing_city: this.state.mailing_city,
					mailing_state: this.state.mailing_state,
					mailing_postal_code: this.state.mailing_postal_code,
					phone_number: this.state.phone_number
				}
			},
			error: (response) => {
				// console.log('Create account call failed.', response.responseJSON);
				this.setState({
					// errorsList: response.responseJSON.errors, // Enable for errors list
					fieldErrors: response.responseJSON.field_errors // Enable for field errors
				});
				window.scrollTo({
					top: 0,
					left: 0,
					behavior: 'smooth'
				});
			}
		}).done((response, status) => {
			// console.log('Create account call successful.', response, status);
			if (!this.props.isEditing) {
				this.props.continueLocation(
					response.data.id,
					response.data.phone_number
				);
			}

			if (this.props.isEditing) {
				window.location.href = `/accounts/1`;
			}
		});
	}

	loadData() {
		// console.log('Account loadData started');
		// console.log('Account loadData', this.props);

		$.ajax({
			type: 'GET',
			url: this.props.get_account_endpoint.replace('id', 1)
		}).done((payload) => {
			const result = payload;
			// console.log('Account loadData done', result);
			this.setState({
				name: result.data.name,
				mailing_address_1: result.data.mailing_address_1,
				mailing_address_2: result.data.mailing_address_2,
				mailing_city: result.data.mailing_city,
				mailing_state: result.data.mailing_state,
				mailing_postal_code: result.data.mailing_postal_code,
				phone_number: result.data.phone_number
			});
		});
	}
}
